import { apiGuidesNavConfig } from './apiGuides';
import { appsNavConfig } from './apps';
import { cmsDevelopmentNavConfig } from './cmsDevelopment';
import { crmCustomizationNavConfig } from './crmCustomization';

/**
 * The array of secondary nav configs for the `/guides` section of the site.
 */
export default (() => [apiGuidesNavConfig, appsNavConfig, cmsDevelopmentNavConfig, crmCustomizationNavConfig]);